import React, { useState } from 'react';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import { projectsData } from '../data/projects';
import './Projects.css';

const Projects = () => {
  const data = projectsData;
  const [showAll, setShowAll] = useState(false);
  const initialProjectsCount = 6;
  const visibleProjects = showAll ? data.projects : data.projects.slice(0, initialProjectsCount);
  const hasMoreProjects = data.projects.length > initialProjectsCount;

  return (
    <section id="projects" className="projects-section">
      <div className="section-heading fade-in-up">
        <h2>{data.heading}</h2>
        <p>{data.description}</p>
      </div>
      <div className="projects-grid">
        {visibleProjects.map((project) => (
          <div key={project.id} className="project-card fade-in-up">
            <div className={`project-image ${project.id === 1 || project.id === 3 ? 'diagram-image' : ''}`}>
              <img src={project.image} alt={project.title} />
              <div className="project-overlay">
                {project.github && (
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                    aria-label="GitHub"
                  >
                    <FaGithub />
                  </a>
                )}
                {project.demo && (
                  <a
                    href={project.demo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                    aria-label="Demo"
                  >
                    <FaExternalLinkAlt />
                  </a>
                )}
              </div>
            </div>
            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {hasMoreProjects && (
        <div className="show-more-container">
          <button 
            className="btn-show-more" 
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )}
    </section>
  );
};

export default Projects;

